<template>
  <div
    id="devmg"

    v-loading.fullscreen.lock="loading"
    element-loading-text="Waiting...."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-row style="margin-left: 20px;">

      <el-col :span="3"  style="margin-left: 20px;">
        <el-input    v-model="search" placeholder="输入设备名关键字"  prefix-icon="el-icon-search" ></el-input>
      </el-col>

       <el-col :span="1" >
         <el-button type="success" icon="el-icon-search" @click="researchdev">搜索</el-button>
       </el-col >

        <el-col :span="8" style="margin-left: 20px;">
        <el-button type="primary" icon="el-icon-plus" @click="func_adddevic"  v-if="isroot" >添加设备</el-button>
        <el-button type="success" icon="el-icon-refresh" @click="reflash_devlist">刷新设备</el-button>
        <el-button type="success" icon="el-icon-s-operation" @click="revols">批量调节音量</el-button>
        </el-col>
    </el-row>
  <br/>
 <el-alert v-show="has_warning"
    title="红色标注行:代表没有关闭提示音(设备会报连接成功或者是连接失败,仅仅用作安装调试,安装调试完之后一定记得关闭提示音);关闭提示音红色警告行会恢复正常"
    type="error">
  </el-alert>

    <el-table :data="tableData"  style="width: 1610px;"   :row-class-name="tableRowClassName"     highlight-current-row border   >
      <el-table-column type="index" label="编号" width="50" align="center"></el-table-column>
<!--      <el-table-column prop="tag2" label="编码" width="80"></el-table-column>
      <el-table-column prop="tag1" label="区域" width="100"></el-table-column> -->
      <el-table-column prop="devname"  label="设备名" width="200"> </el-table-column>
      <el-table-column prop="device_seed" label="序列号[Seed]" width="280"></el-table-column>
      <el-table-column prop="changetime" label="信息更新时间" width="200"></el-table-column>
      <el-table-column label="播放状态" width="100">
         <template slot-scope="props">
            <el-tag type="success"  v-show="props.row.status ==1 "  >在线</el-tag>
            <el-tag type="warning"  v-show="props.row.status ==2 "  >正在播放</el-tag>
            <el-tag type="info"     v-show="props.row.status == 0"  >不在线</el-tag>
            <el-tag type="danger"   v-show="props.row.status == -1 " > 等待消息 </el-tag>
            <el-tag type="danger"   v-show="props.row.status ==-2 " > 到期禁用 </el-tag>
         </template>
      </el-table-column>
      <el-table-column label="声音" align="center">
        <template slot-scope="scopeeee">
          <el-button
            class="test"
            type="warning"
            @click.native.prevent="goAdjustVolume(scopeeee.$index, tableData)"
            size="small"
            plain
          >调节音量</el-button>
          <el-button
            class="test"
            type="danger"
            v-show="scopeeee.row.kind != 2 "
            @click.native.prevent="closePromptTone(scopeeee.$index, tableData)"
            size="small"
            plain
          >关闭提示</el-button>
          <el-button
            class="test"
            type="danger"
            v-show="scopeeee.row.kind != 1 "
            @click.native.prevent="openPromptTone(scopeeee.$index, tableData)"
            size="small"
            plain
          >提示</el-button>
        </template>

      </el-table-column>
      <el-table-column  label="提示音" width="80">
          <template slot-scope="props">
            <el-tag type="success"  v-show="props.row.kind == 1 " > 已开启 </el-tag>
            <el-tag type="danger"   v-show="props.row.kind == 2" >已关闭</el-tag>
            <el-tag v-show="props.row.kind > 2 " >其他</el-tag>
            <el-tag v-show="props.row.kind < 1 " >y其他</el-tag>
          </template>
      </el-table-column>
	  <el-table-column   label="音量" width="150">

       <el-progress slot-scope="scope"  :percentage= "Math.round(scope.row.vol/63*100)"  ></el-progress>

	  </el-table-column>
    <!--  <el-table-column label="类型" width="60">
        <template slot-scope="props">
          {{props.row.iswarning}}
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-setting"
            v-show="props.row.iswarning=='报警设备'"
            @click.native.prevent="goSetWarning(props.$index, tableData)"
          ></el-button>
		  <el-button
		    size="mini"
		    type="primary"
		    icon="el-icon-setting"
		    v-show="props.row.iswarning=='报警'"
		    @click.native.prevent="goSetWarningauto(props.$index, tableData)"
		  ></el-button>
      <el-button
        size="mini"
        type="primary"
        icon="el-icon-setting"
        v-show="props.row.iswarning=='信号灯'"
        @click.native.prevent="goSetxinhaodengauto(props.$index, tableData)"
      ></el-button>
        </template>
      </el-table-column> -->
 <!--
  <el-table-column prop="ctime" label="时间" width="170"></el-table-column>
 -->
      <el-table-column label="操作" align="center" width="220">
        <template slot-scope="scopssse">
          <el-button
            class="test"
            type="text"
            @click.native.prevent="renameRow(scopssse.$index, tableData)"
            size="small"
          >改名</el-button>
          <el-button
       
            type="text"
            @click.native.prevent="resnRow(scopssse.$index, tableData)"
            size="small"
          >改SN</el-button>
          
              <!-- v-if="isroot" -->
   <!--       <el-button
            type="text"
            @click.native.prevent="rerRow(scopssse.$index, tableData)"
            size="small"
          >改T</el-button>
          http://129.211.117.94:12080/get_user_node.php?username=oxiaom2&passwd=123123qq
          <el-button
            type="text"
            @click.native.prevent="rerqRow(scopssse.$index, tableData)"
            size="small"
          >改Q</el-button> -->
          <el-button
            v-if="isroot"
            style="color:#f56c6c"
            type="text"
            @click.native.prevent="goDeleteRow(scopssse.$index, tableData)"
            size="small"
          >移除</el-button>
        </template>
      </el-table-column>

<!--      <el-table-column prop="py" label="文件(次)" width="100"></el-table-column>
      <el-table-column prop="pyl" label="文件(秒)" width="100"></el-table-column>
      <el-table-column prop="rt" label="实时(次)" width="100"></el-table-column>
      <el-table-column prop="rtl" label="实时(秒)" width="100"></el-table-column> -->
    </el-table>
    <el-dialog title="添加设备" :visible.sync="dialogVisible_adddevice" width="400px">

      <div style="margin-top: 30px;">
        <el-input placeholder="设备名字" v-model="name_adddevice">
          <template slot="prepend">NAME:</template>
        </el-input>

      </div>
      <div style="margin-top: 15px;">
        <el-input placeholder="设备序列号Seed" v-model="seed_adddevice">
          <template slot="prepend">SEED:</template>
        </el-input>
      </div>
      <div style="margin-top: 15px;">
        <el-input placeholder="设备公钥SQR" v-model="sqr_adddevice">
              <template slot="prepend">S Q R:</template>
        </el-input>
      </div>
 <!--    <div style="margin-top: 15px;">
        <el-input placeholder="区域标签A" v-model="tag1">
          <template slot="prepend">TAG A:</template>
        </el-input>
      </div>
      <div style="margin-top: 15px;">
        <el-input placeholder="编码标签B" v-model="tag2">
          <template slot="prepend">TAG B:</template>
        </el-input>
      </div> -->
<!--      <div style="margin-top: 15px;">

        <el-row>
          <el-col :span="8">
            <el-button  type="info" plain disabled >设备类型：</el-button>
          </el-col>
              <el-col :span="8">
              <el-select v-model="devkindkind"   placeholder="请选择">
                <el-option
                  v-for="item in optionsdevkind"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                   >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
      </div> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible_adddevice=false">取消</el-button>
        <el-button type="primary" @click="func_addone_device">添加设备</el-button>
      </span>
    </el-dialog>

    <el-dialog title="调节音量" :visible.sync="dialogVisible_adddevice2" width="400px">
      <div class="block">
        <el-slider v-model="volumeAdjust.vol1" :step="10"></el-slider>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible_adddevice2=false">取消</el-button>
        <el-button type="primary" @click="adjustVolume">保存</el-button>
      </span>
    </el-dialog>
<!--
    <el-dialog title="报警设置" :visible.sync="dialogVisible_adddevice3" width="500px">


        <el-row>
          <el-button @click="dialogVisible_adddevice3=false"   >取消</el-button>
          <el-button  type="primary"  @click="setWarningcancel" >注销联动报警</el-button>
          <el-button type="primary" @click="setWarning">注册联动报警</el-button>

        </el-row>
        <br/>
        <el-row>
          <el-button @click="dialogVisible_adddevice3=false"   >取消</el-button>
          <el-button  type="primary"  @click="setWarningcancelauto" >注销自动设备报警</el-button>
          <el-button type="primary" @click="setWarningauto">注册自动设备报警</el-button>

        </el-row>

      </span>
    </el-dialog>
	<el-dialog title="自动报警设置" :visible.sync="dialogVisible_adddevice6" width="500px">
				<el-button @click="dialogVisible_adddevice6=false"   >取消</el-button>
	    <el-button  type="primary"  @click="setWarningcancelauto" >注销自动设备报警</el-button>
	    <el-button type="primary" @click="setWarningauto">注册自动设备报警</el-button>
	  </span>
	</el-dialog> -->
  <!--

  <el-dialog title="信号灯详细设置及状态" :visible.sync="dialogVisible_adddevice7" width="500px">

      <el-form ref="form" :model="xinhaodengset" label-width="80px">
          <el-form-item label="设备名字:" style="text-align:left">
              <el-tag  type="info" >{{xinhaodengset.name}}</el-tag>
          </el-form-item>
          <el-form-item label="工作模式:" style="text-align:left">

              <el-select v-model="xinhaodengset.mode"   placeholder="请选择">
                  <el-option
                    v-for="item in options_fuck1"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                     >
                  </el-option>
                  </el-option>
                </el-select>
                 <el-button @click="fuck_liangdengmode"   >修改亮灯模式</el-button>
          </el-form-item>
          <el-form-item label="南北秒数:" style="text-align:left">
             <el-tooltip class="item" effect="dark" content="南北亮灯绿灯秒数最小5秒最大180秒" placement="top-end">
               <el-input-number v-model="xinhaodengset.nsgo"  :min="5" :max="180"  ></el-input-number>
             </el-tooltip>
             <el-button @click="fuck_liangdengnsgo"   >修改亮灯模式</el-button>
          </el-form-item>
          <el-form-item v-if="xinhaodengset.mode == 1"  label="南北左转:" style="text-align:left">
             <el-tooltip class="item" effect="dark" content="南北左转亮灯绿灯秒数最小5秒最大180秒" placement="top-end">
               <el-input-number v-model="xinhaodengset.nsleft"  :min="5" :max="180"  ></el-input-number>
             </el-tooltip>
             <el-button @click="fuck_liangdengnsleft"   >修改亮灯模式</el-button>
          </el-form-item>
          <el-form-item label="东西秒数:" style="text-align:left">
             <el-tooltip class="item" effect="dark" content="东西亮灯绿灯秒数最小5秒最大180秒" placement="top-end">
               <el-input-number v-model="xinhaodengset.wego"  :min="5" :max="180"  ></el-input-number>
             </el-tooltip>
             <el-button @click="fuck_liangdengwego"   >修改亮灯模式</el-button>
          </el-form-item>
          <el-form-item v-if="xinhaodengset.mode == 1" label="东西左转:" style="text-align:left">
             <el-tooltip class="item" effect="dark" content="东西左转亮灯绿灯秒数最小5秒最大180秒" placement="top-end">
               <el-input-number v-model="xinhaodengset.weleft"  :min="5" :max="180"  ></el-input-number>
             </el-tooltip>
             <el-button @click="fuck_liangdengweleft"   >修改亮灯模式</el-button>
          </el-form-item>
          <el-form-item   label="更新时间:" style="text-align:left">
            {{xinhaodengset.time}}
          </el-form-item>
          <el-form-item   label="当前状态:" style="text-align:left">
                  <el-image :src="xinhaodengset.imagesrc">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image><el-button @click="fuck_liangdengshuaxin"   >刷新</el-button>
          </el-form-item>
      </el-form>
  </el-dialog> -->

	  <el-dialog  title="批量调节音量" :visible.sync="dialogVisible_adddevice4" width="760px">
		<div class="edit_dev">
			<el-transfer
				filterable
				 :titles="['所有设备', '需要被调节音量的设备']"
				v-model="volvalue"
				:data="voldata"   >
			  </el-transfer>
		</div>
				<span class="demonstration">音量</span>
				<div class="block">
				  <el-slider v-model="volumeAdjust.vol3" :step="10"></el-slider>
				</div>

				<br/>
					<el-button type="primary" @click="adjustVolumes">保存</el-button>
				<el-button @click="dialogVisible_adddevice4=false"   >取消</el-button>
	</el-dialog>
  </div>


</template>
<style>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-table .error-row {
    background: #ff8f97;
  }
</style>
<script>
import axios from "axios";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};
let Base64 = require("js-base64").Base64;
export default {
  data() {
    return {
    devkindkind:0,
    has_warning:false,
    optionsdevkind: [
          {
            value: 0,
            label: '音响'
          }, {
            value: 1,
            label: '报警A'
          }, {
            value: 2,
            label: '报警B'
          }, {
            value: 3,
            label: '报警C'
          }, {
            value: 12,
            label: '输入A'
          }, {
            value: 13,
            label: '输入B'
          }, {
            value: 14,
            label: '输出A'
          }, {
            value: 15,
            label: '输出B'
          }, {
            value: 16,
            label: 'TTSA'
          }, {
            value: 17,
            label: 'TTSB'
          },
        ],
      search:"",
      volvalue:[],
      voldata:[],
      volumeAdjust: {
        ip: "",
        port: "",
        seed: "",
        vol1: 0,
        vol2: 0,
        vol3: 0,
        vol4: 0
      },
      warningSet: {
        flag: true,
        seedList1: {
          data: [],
          value: []
        },
        seedList2: {
          data: [],
          value: []
        },
        file1: "",
        file2: "",
        portwr: "",
        portct: "",
        seed: "",
        ip: ""
      },
      xinhaodengset:{
        seed:"",
        name:"",
        ip:"",
        portct:"",
        xhstatus:"",
        nsgo:0,
        nsleft:0,
        wego:0,
        weleft:0,
        nowk:0,
        mode:0,
        imagesrc:"",
        time:""
      },
      loading: false,
      options: [],
      nodeid: "",
      isroot: false,
      tableData: [],
      tableDatatmp: [],
      dialogVisible_adddevice7:false,
      dialogVisible_adddevice6:false,
      dialogVisible_adddevice4:false,
      tableDatafilelist: [],
      dialogVisible_adddevice : false,
      dialogVisible_adddevice2: false,
      dialogVisible_adddevice3: false,
      name_adddevice: "",
      seed_adddevice: "",
      seed_ofnode: "",
      tag1: "区域标签A可选",
      tag2: "编码标签B可选",
      type: "1",
      device_status: "1",
      sqr_adddevice: "",
      save_backdata: "",
      dialogVisible_save_back: false,
      dialogVisible_save_back_detail: false,
      options_fuck1: [
        {
          value: 1,
          label: '左转直行分别亮灯'
        }, {
          value: 2,
          label: '左转直行同时亮灯',
          disabled: true
        }
      ],
    };
  },
  created() {
    this.reflash_devlist();
    if (sessionStorage.getItem("master_id") == -1) {
      this.isroot = true;
    }
  },
  methods: {

    researchdev(){
        console.log("researchdev");
        console.log(this.search);
        this.tableData=this.tableDatatmp;
        this.tableData=this.tableData.filter(data => !this.search||data.devname.includes(this.search));
    },
    revols(){
      this.dialogVisible_adddevice4= true;


    },
    goSetWarning( index , rows ) {
      this.warningSet.ip = rows[index].nodeip;
      this.warningSet.portct = rows[index].nodeport3;
      this.warningSet.seed = rows[index].seed;
      this.dialogVisible_adddevice3 = true;
    },
    goSetWarningauto( index , rows ) {
      this.warningSet.ip = rows[index].nodeip;
      this.warningSet.portct = rows[index].nodeport3;
      this.warningSet.seed = rows[index].seed;
      this.dialogVisible_adddevice6 = true;
    },
		setWarningcancelauto() {
			  console.log(this.warningSet);
			  let url_bihe ="http://x/x/x/x/5peg5oql6K2m6YWN572u.mp3";
			  let url_duankai="http://x/x/x/x/5peg5oql6K2m6YWN572u.mp3"
			  let data = new FormData();
			  data.append("username", sessionStorage.getItem("username"));
			  data.append("passwd", sessionStorage.getItem("passwd"));
			  data.append("user_id", sessionStorage.getItem("id"));
			  data.append("enable", 0);
			  data.append("portct", this.warningSet.portct);
			  data.append("seed", this.warningSet.seed);
			  data.append("ip", this.warningSet.ip);
			  data.append("id", -2);
			  data.append("url_bihe" , url_bihe );
			  data.append("url_duankai" , url_duankai );
			  axios
			    .post("/warningsetauto.php", data)
			    .then(
			      function(res) {
			        if (res.data.res) {
			          console.log(res.data);
			          this.$notify.success({
			            title: "Info",
			            message: "报警注销成功",
			            showClose: false
			          });
			        } else {
			          this.$notify.success({
			            title: "Info",
			            message: "报警注销出现异常",
			            showClose: false
			          });
			        }
			      }.bind(this)
			    )
			    .catch(function(res) {
			      console.log(res);
			    });
			  this.dialogVisible_adddevice3 = false;
			},

    closePromptTone(index, rows) {
      this.loading = true;
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      data.append("dsv", 2);
      data.append("sn", rows[index].device_seed );
      axios
        .post("/user/sndebug", data)
        .then(
          function(res) {
            if (res.data.res) {
              this.loading = false;
              this.$notify.success({
                title: "Info",
                message: "关闭成功",
                showClose: false
              });
              rows.splice(index, 1);
              this.reflash_devlist();
            } else {
              console.log(res.data);
              this.$notify.success({
                title: "Info",
                message: "关闭失败",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    openPromptTone(index, rows) {
      this.loading = true;
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      data.append("dsv", 1);
      data.append("sn", rows[index].device_seed );
      axios
        .post("/user/sndebug", data)
        .then(
          function(res) {
            if (res.data.res) {
              this.loading = false;
              this.$notify.success({
                title: "Info",
                message: "开启成功",
                showClose: false
              });
              rows.splice(index, 1);
              this.reflash_devlist();
            } else {
              console.log(res.data);
              this.$notify.success({
                title: "Info",
                message: "开启失败",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    goAdjustVolume(index, rows) {
      // if (rows[index].vol == -1) {
      //   this.$message({
      //     message: "设备未上报",
      //     type: "warning"
      //   });
      // } else {
        if (parseInt(rows[index].vol) <= 1) {
          this.volumeAdjust.vol1 = 0;
        } else if (parseInt(rows[index].vol) <= 15) {
          this.volumeAdjust.vol1 = 10;
        } else if (parseInt(rows[index].vol) <= 25) {
          this.volumeAdjust.vol1 = 20;
        } else if (parseInt(rows[index].vol) <= 30) {
          this.volumeAdjust.vol1 = 30;
        } else if (parseInt(rows[index].vol) <= 35) {
          this.volumeAdjust.vol1 = 40;
        } else if (parseInt(rows[index].vol) <= 40) {
          this.volumeAdjust.vol1 = 50;
        } else if (parseInt(rows[index].vol) <= 45) {
          this.volumeAdjust.vol1 = 60;
        } else if (parseInt(rows[index].vol) <= 50) {
          this.volumeAdjust.vol1 = 70;
        } else if (parseInt(rows[index].vol) <= 55) {
          this.volumeAdjust.vol1 = 80;
        } else if (parseInt(rows[index].vol) <= 60) {
          this.volumeAdjust.vol1 = 90;
        } else {
          this.volumeAdjust.vol1 = 100;
        }
        console.log(rows[index].device_seed);
        this.volumeAdjust.seed = rows[index].device_seed;
        this.dialogVisible_adddevice2 = true;
     // }
    },
    adjustVolume() {
      switch (this.volumeAdjust.vol1) {
        case 0:
          this.volumeAdjust.vol2 = 1;
          break;
        case 10:
          this.volumeAdjust.vol2 = 15;
          break;
        case 20:
          this.volumeAdjust.vol2 = 25;
          break;
        case 30:
          this.volumeAdjust.vol2 = 30;
          break;
        case 40:
          this.volumeAdjust.vol2 = 35;
          break;
        case 50:
          this.volumeAdjust.vol2 = 40;
          break;
        case 60:
          this.volumeAdjust.vol2 = 45;
          break;
        case 70:
          this.volumeAdjust.vol2 = 50;
          break;
        case 80:
          this.volumeAdjust.vol2 = 55;
          break;
        case 90:
          this.volumeAdjust.vol2 = 60;
          break;
        case 100:
          this.volumeAdjust.vol2 = 63;
      }
      console.log(this.volumeAdjust);

      let datadf = new FormData();
      datadf.append("id", sessionStorage.getItem("id"));
      datadf.append("token", sessionStorage.getItem("token"));
      datadf.append("snlist", this.volumeAdjust.seed );
      datadf.append("vol", this.volumeAdjust.vol2 );
      axios
        .post("/user/editvols",  datadf)
        .then(
          function(res) {
            if (res.data.res) {
              console.log(res.data);
              this.$notify.success({
                title: "Info",
                message: "修改成功",
                showClose: false
              });
              rows.splice(index, 1);
              this.reflash_devlist();
            } else {
              console.log(res.data);
              this.$notify.success({
                title: "Info",
                message: "修改失败",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
      this.dialogVisible_adddevice2 = false;
    },
    adjustVolumes() {
      this.dialogVisible_adddevice4=false;
      switch (this.volumeAdjust.vol3) {
        case 0:
          this.volumeAdjust.vol4 = 1;
          break;
        case 10:
          this.volumeAdjust.vol4 = 15;
          break;
        case 20:
          this.volumeAdjust.vol4 = 25;
          break;
        case 30:
          this.volumeAdjust.vol4 = 30;
          break;
        case 40:
          this.volumeAdjust.vol4 = 35;
          break;
        case 50:
          this.volumeAdjust.vol4 = 40;
          break;
        case 60:
          this.volumeAdjust.vol4 = 45;
          break;
        case 70:
          this.volumeAdjust.vol4 = 50;
          break;
        case 80:
          this.volumeAdjust.vol4 = 55;
          break;
        case 90:
          this.volumeAdjust.vol4 = 60;
          break;
        case 100:
          this.volumeAdjust.vol4 = 63;
      }
      console.log(this.volumeAdjust);
      var seedss=[];

      for(var si =0;si<this.volvalue.length;si++ ){
             seedss.push( this.volvalue[si])
      }
      if(seedss.length <1){
        return;
      }
      let seedsstr = seedss.join("|");

      let datadf = new FormData();
      datadf.append("id", sessionStorage.getItem("id"));
      datadf.append("token", sessionStorage.getItem("token"));
      datadf.append("snlist", seedsstr);
      datadf.append("vol", this.volumeAdjust.vol4);
      axios
        .post("/user/editvols", datadf).then(
          function(res) {
            if (res.data.res) {
              console.log(res.data);
              this.$notify.success({
                title: "Info",
                message: "修改成功",
                showClose: false
              });

              this.reflash_devlist();
            } else {
              console.log(res.data);
              this.$notify.success({
                title: "Info",
                message: "修改失败",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
      this.dialogVisible_adddevice2 = false;
    },
    goDeleteRow(index, rows) {
      this.$confirm("此操作将永久删除该设备, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteRow(index, rows);
        })
        .catch(() => {});
    },
    open5() {
      this.$alert(this.save_backdata, "配置详情", {
        dangerouslyUseHTMLString: false
      });
    },
    handleClose_save_back() {},
    func_addone_device() {
      this.dialogVisible_adddevice = false;
      if (this.name_adddevice.trim() == "") {
        this.$notify.success({
          title: "Info",
          message: "设备名字不能为空",
          showClose: true
        });
        return;
      }
      if (
        this.seed_adddevice.trim() == "" ||
        this.seed_adddevice.trim().length != 32
      ) {
        this.$notify.success({
          title: "Info",
          message: "设备序列号 seed 不正确",
          showClose: true
        });
        return;
      }
      if(this.sqr_adddevice.trim() == "" ||  this.sqr_adddevice.trim().length != 32 ){
            this.$notify.success({
              title: 'Info',
              message: '设备序公钥 sqr 不正确',
              showClose: true
            });
            return;
      }

      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      data.append("name", this.name_adddevice);
      data.append("sn", this.seed_adddevice+"|"+this.sqr_adddevice);
      axios
        .post("/user/deviceadd", data)
        .then(
          function(res) {
            if (res.data.res) {
              this.$notify.success({
                title: "Info",
                message: "添加成功",
                showClose: false
              });
              this.reflash_devlist();
            } else {
              this.$notify.success({
                title: "Info",
                message: "添加设备出现异常",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },

    func_adddevic() {
      this.dialogVisible_adddevice = true;
    },
    func_savedevic() {
      const loading = this.$loading({
        lock: true,
        text: "Processing",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
        target: document.querySelector(".div1")
      });



      axios
        .get("/create_config.php")
        .then(
          function(res) {
            if (res.data.res) {
              this.save_backdata = res.data.config;
              this.dialogVisible_save_back = true;
              loading.close();
            } else {
              this.$notify.success({
                title: "Info",
                message: "哪里出现错误了",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    deleteRow(index, rows) {
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      data.append("snid", rows[index].id);
      axios
        .post("/user/deldevs", data )
        .then(
          function(res) {
            if (res.data.res) {
              this.$notify.success({
                title: "Info",
                message: "删除成功",
                showClose: false
              });
              rows.splice(index, 1);
              this.reflash_devlist();
            } else {
              this.$notify.success({
                title: "Info",
                message: "删除失败",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res){
          console.log(res);
        });
    },
    renameRow(index, rows) {
      let seed = rows[index].seed;
      let devid = rows[index].id;
      let username = sessionStorage.getItem("username");
      let passwd = sessionStorage.getItem("passwd");
      this.$prompt("New NAME:", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/,
        inputErrorMessage: "格式不正确"
      })
      .then(({ value }) => {
        if (value.length >= 30) {
          this.$message({
            type: "info",
            message: "名字输入不合规"
          });
          return;
        }
        console.log(value);

          let devid = rows[index].id;
          let data = new FormData();
          data.append("id", sessionStorage.getItem("id"));
          data.append("token", sessionStorage.getItem("token"));
          data.append("newname", value );
          data.append("devid"  , devid  );
          axios
            .post("/user/redevname", data )
            .then(
              function(res) {
                if (res.data.res) {
                  this.$notify.success({
                    title: "Info",
                    message: "修改成功",
                    showClose: false
                  });
                  rows.splice(index, 1);
                  this.reflash_devlist();
                } else {
                  this.$notify.success({
                    title: "Info",
                    message: "修改失败",
                    showClose: false
                  });
                }
              }.bind(this)
            )
            .catch(function(res) {
              console.log(res);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入"
          });
        });
    },
    resnRow(index, rows) {
      let seed = rows[index].device_seed;
      let devid = rows[index].id;
      this.$prompt("New SEED:"+seed+"  INDEX:"+index, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^(?!\d+$)[\da-zA-Z]+$/,
        inputErrorMessage: "格式不正确"
      })
        .then(({ value }) => {
          if (value.length != 32) {
            this.$message({
              type: "info",
              message: "输入编码不正确 请认真输入"
            });
            return;
          }
          let devid = rows[index].id;
          let data = new FormData();
          data.append("id", sessionStorage.getItem("id"));
          data.append("token", sessionStorage.getItem("token"));
          data.append("newsn", value );
          data.append("devid"  , devid  );
          axios
            .post("/user/resn", data )
            .then(
              function(res) {
                if (res.data.res) {
                  this.$notify.success({
                    title: "Info",
                    message: "修改成功",
                    showClose: false
                  });
                  rows.splice(index, 1);
                  this.reflash_devlist();
                } else {
                  this.$notify.success({
                    title: "Info",
                    message: "修改失败",
                    showClose: false
                  });
                }
              }.bind(this)
            )
            .catch(function(res) {
              console.log(res);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入"
          });
        });
    },

    rerqRow(index, rows) {
      let seed = rows[index].seed;
      let devid = rows[index].id;
      let username = sessionStorage.getItem("username");
      let passwd = sessionStorage.getItem("passwd");
      this.$prompt("New TAG1区域标签:"+seed+"  INDEX:"+index, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputErrorMessage: "格式不正确"
      })
        .then(({ value }) => {
          if (value.length <2 ) {
            this.$message({
              type: "info",
              message: "输入编码不正确 请认真输入"
            });
            return;
          }
          let seed = rows[index].seed;
          let newseed = value;
          let devid = rows[index].id;
          let username = sessionStorage.getItem("username");
          let passwd = sessionStorage.getItem("passwd");
          axios
            .get("/retg1.php", {
              params: {
                olseed:   seed,
                retg2:    newseed,
                devid:    devid,
                username: username,
                passwd:   passwd
              }
            })
            .then(
              function(res) {
                if (res.data.res) {
                  this.$notify.success({
                    title: "Info",
                    message: "修改成功",
                    showClose: false
                  });
                  rows.splice(index, 1);
                  this.reflash_devlist();
                } else {
                  this.$notify.success({
                    title: "Info",
                    message: "修改失败",
                    showClose: false
                  });
                }
              }.bind(this)
            )
            .catch(function(res) {
              console.log(res);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入"
          });
        });
    },
    rerRow(index, rows) {
      let seed = rows[index].seed;
      let devid = rows[index].id;
      let username = sessionStorage.getItem("username");
      let passwd = sessionStorage.getItem("passwd");
      this.$prompt("New TAG2编码标签:"+seed+"  INDEX:"+index, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^(?!\d+$)[\da-zA-Z]+$/,
        inputErrorMessage: "格式不正确"
      })
        .then(({ value }) => {
          if (value.length <2 ) {
            this.$message({
              type: "info",
              message: "输入编码不正确 请认真输入"
            });
            return;
          }
          let seed = rows[index].seed;
          let newseed = value;
          let devid = rows[index].id;
          let username = sessionStorage.getItem("username");
          let passwd = sessionStorage.getItem("passwd");
          axios
            .get("/retg2.php", {
              params: {
                olseed: seed,
                retg2: newseed,
                devid: devid,
                username: username,
                passwd: passwd
              }
            })
            .then(
              function(res) {
                if (res.data.res) {
                  this.$notify.success({
                    title: "Info",
                    message: "修改成功",
                    showClose: false
                  });
                  rows.splice(index, 1);
                  this.reflash_devlist();
                } else {
                  this.$notify.success({
                    title: "Info",
                    message: "修改失败",
                    showClose: false
                  });
                }
              }.bind(this)
            )
            .catch(function(res) {
              console.log(res);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入"
          });
        });
    },
    handleClose_adddevice3() {
      this.dialogVisible_adddevice3 = false;
    },
    tableRowClassName({ row, rowIndex }) {
      // if (rowIndex%4=== 1) {
      //   return "warning-row";
      // } else if (rowIndex%4=== 3) {
      //   return "success-row";
      // // }
      // console.log(rowIndex,this.tableData[rowIndex].kind,row);

      if(row.kind == 1 ){
          return "error-row";
      }else if (row.kind == 2){
          return "success-row";
      }else if(row.status > 0){
          return "success-row";
      }else{
          return "warning-row";
      }

      return "";
    },
    reflash_devlist: function() {
      this.warningSet.seedList = [];
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      console.log(data);
      this.voldata = [];
      axios
        .post("/user/fnckukei/listmydevice",  data )
        .then(
          function(res) {
            if (res.data.res) {
              this.tableData = res.data.results;
              this.tableDatatmp = res.data.results;
              this.has_warning = false;
              this.voldata = [];
              for(var i in this.tableData){
                if(this.tableData[i].kind == 1 ){

                   this.has_warning = true;
                }
                if(this.tableData[i].vol ==  -1){
                    this.tableData[i].vol =  0;
                }
                this.voldata.push({
                	key: this.tableData[i].device_seed,
                	label: this.tableData[i].devname
                });
              }

              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
  }
};
</script>

<style scoped>
#devmg {
  padding-top: 20px;
  width: 100%;
}
.el-table {
  margin: 20px ;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #a175f9;
}
.edit_dev  {
	text-align:left ;
	/deep/ .el-transfer-panel {
		width:300px;
	}
}
</style>



// WEBPACK FOOTER //
// src/xxxvue/device_Mg.vue